import React, { useEffect, useState } from "react";
import "./StyleComponents/Navigation.css";

const SECTIONS = [
    { id: "home", label: "Home" },
    { id: "who", label: "Who You Are" },
    { id: "smile", label: "Your Smile" },
    { id: "magic", label: "Your Magic" },
    { id: "movie", label: "Movie" },
];

export default function Navigation() {
    const [activeId, setActiveId] = useState("home");

    // Highlight current section while scrolling
    useEffect(() => {
        const ids = SECTIONS.map((s) => s.id);
        const els = ids
            .map((id) => document.getElementById(id))
            .filter(Boolean);

        if (!els.length) return;

        const obs = new IntersectionObserver(
            (entries) => {
                const visible = entries
                    .filter((e) => e.isIntersecting)
                    .sort((a, b) => (b.intersectionRatio ?? 0) - (a.intersectionRatio ?? 0))[0];

                if (visible?.target?.id) setActiveId(visible.target.id);
            },
            {
                root: null,
                rootMargin: "-90px 0px -60% 0px",
                threshold: [0.2, 0.35, 0.5, 0.65, 0.8],
            }
        );

        els.forEach((el) => obs.observe(el));
        return () => obs.disconnect();
    }, []);

    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (!el) return;

        el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <header className="romNav">
            <nav className="romNavInner" aria-label="Site">
                {SECTIONS.map((s) => (
                    <button
                        key={s.id}
                        type="button"
                        className={`romNavLink ${activeId === s.id ? "isActive" : ""}`}
                        onClick={(e) => {
                            scrollTo(s.id);
                            e.currentTarget.blur(); // ⭐ remove stuck hover/focus
                        }}
                    >
                        {s.label}
                    </button>
                ))}
            </nav>
        </header>
    );
}
